export default __webpack_public_path__ + "static/media/footer-phone-display.92698700.png";